import { IconButton } from '@chakra-ui/react';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';

import { useAccordionContext } from './Accordion';

export const AccordionButton = () => {
  const { isOpen, toggle } = useAccordionContext();
  const icon = isOpen ? <HiChevronUp /> : <HiChevronDown />;

  return <IconButton aria-label="Accordion button" icon={icon} onClick={toggle} borderRadius="md" variant="outline" />;
};
